import React, { useState } from "react"
import { IInnRegistryDto } from "../../../types/inn/IInnRegistryDto"
import { ModalConfirm } from "../../common/element/ModalConfirm"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { IModalMessage } from "../../../types/error/IModalMessage"

export const ClientInnPopUpListItem: React.FC<{
  inn: IInnRegistryDto
  remove: (inn: string) => void
}> = ({ inn, remove }) => {
  const [modalConfirm, setModalConfirm] = useState<IModalMessage>()
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)

  const confirmRemove = (val: any) => {
    if (val) {
      remove(val)
    }
  }

  const getHumanStatus = (status: string | undefined) => {
    switch (status) {
      case "BLOCKED":
        return "Заблокирована"
      case "APPROVED":
        return "Одобрена"
      case "PENDING":
        return "На проверке"
      default:
        return "На проверке"
    }
  }

  return (
    <>
      <ModalConfirm message={modalConfirm} setMessage={setModalConfirm} />
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <li className="inn_item_new">
        {inn.status === "BLOCKED" ? (
          <p
            className="four-card-text"
            onClick={() =>
              setModalMessage({
                ...modalMessage,
                title: "Инфо",
                text: `Компания заблокирована по причине: ${inn.reason}`
              })
            }
          >
            {inn.inn}
          </p>
        ) : (
          <p className="four-card-text">{inn.inn}</p>
        )}
        <p className="four-card-text">{inn.name}</p>
        <p className="four-card-text">{inn.address}</p>
        <p className="four-card-text">{inn.comment || "-"}</p>
        <p className="four-card-text">{getHumanStatus(inn.status)}</p>
        <button
          className="delete_item"
          onClick={() =>
            setModalConfirm({
              title: "Удалить ИНН?",
              text: `Вы действительно желаете удалить ИНН ${inn.inn} (${inn.name})?`,
              callbackValue: inn.inn,
              _callback: confirmRemove
            })
          }
        />
      </li>
    </>
  )
}
